export const validateUploading = (file, maxFileSize = 1.5, noGif) => {
    const validFileTypes = ['image/png', 'image/jpeg', 'image/gif'];
    if(noGif){
        validFileTypes.pop()
    }
    let errMessage = '';
    if(file.size > maxFileSize * 1048576) {
        errMessage = `Max. file size is ${maxFileSize}MB`
    }
    if(!validFileTypes.includes(file.type)) {
        errMessage = 'Not valid file type';
    }
    return errMessage;
}